import { ApiError } from "./ApiError";

export default class AuthenticationError extends ApiError {
  code = 401;
}
